import { Kbo } from "@models/configurators/configurator-di";
import { CToken } from "@models/configurators/ctoken";
import { KbObjectManager } from "@models/configurators/kb-object-manager";
import { UiObject } from "@models/configurators/ui-object";
import { IPageControl } from "@models/entity-models";

@Kbo(CToken.PageControl)
export class PageControl extends UiObject implements IPageControl {

    constructor(kom: KbObjectManager) {
        super(kom);
    }

    public padding: string;

    public allowedChildren(rootType: CToken) {
        if (rootType == CToken.Configurator){
            return [
                CToken.Page
            ]
        } else {
            return []; // pages are filled in by the consumer, not in the layout
        }
    }
}
